import { Component } from 'react';
import AppEvents from '../../pages/App/AppEvents';

export default class Transition extends Component {
  constructor(props) {
    super(props);
    this.getEventTokenEvent = null; // AppEvents.subscribe(AppEvents.EVENT_REGISTER.GET_EVENT_TOKEN);
  }
  // componentWillUnmount() {
    // document.querySelector('.container-fluid').classList.remove('containerAnimation');
    // AppEvents.unsubscribe(this.getEventTokenEvent);
  // }
  // componentDidMount() {
    // document.querySelector('.container-fluid').classList.add('containerAnimation');
    // this.getEventTokenEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.GET_EVENT_TOKEN);
    // if (this.props.eventId && this.getEventTokenEvent) {
    //   AppEvents.publish(this.getEventTokenEvent, [this.props.eventId]);
    // }
  // }
  // constructor(props) {
  //   super(props);
  //   this.TRANSITION_STATE = {
  //     START: 'START',
  //     STOP: 'STOP',
  //   };
  // }
  updateTransitionClass = () => {
    if (typeof document !== 'undefined' && document.querySelector('.container-fluid')) {
      if (this.props.transitionState === 'STOP') {
        document.querySelector('.container-fluid').classList.remove('containerAnimation');
      } else if (this.props.transitionState === 'START') {
        document.querySelector('.container-fluid').classList.add('containerAnimation');
      }
    }
  }

  render() {
    // this.updateTransitionClass();
    return null;
  }
}
